// extracted by mini-css-extract-plugin
module.exports = {"root":"_209220","fixedImageContainer":"_c70376","body":"_c32b67","header":"_090c94","name":"_e14098","iconButton":"_64fb92","icon":"_eba659","tagline":"_d2496a"};